import styled from "styled-components";

export const MainContainer = styled.div`
  position: fixed;
  width: 300px;
  margin-top: 6.25rem;
  height: calc(100% - 6.25rem);
  overflow-y: auto;
  padding: 40px;
  gap: 16px;
  background: #f0f4f8;
  scrollbar-color: #f0f4f8 white;
  scrollbar-width: 1px;
  z-index: 1;
`;

export const buttonStyle = {
  width: "100%",
  height: "3.5rem",
  padding: "1rem",
  gap: "0.5rem",
  borderRadius: "0.5rem",
  backgroundColor: "#FFFFFF",
  fontFamily: "Inter",
  fontWeight: 700,
  fontSize: "1rem",
  lineHeight: "1.21rem",
};
